var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMinimartGradeE = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "minimartGradeE",
  width: 35.995,
  height: 35.995,
  viewBox: "0 0 35.995 35.995",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none}.cls-2{fill:#f2c500}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Path_234",
  d: "M0 0h36v36H0z",
  className: "cls-1",
  "data-name": "Path 234"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  id: "Subtraction_1",
  d: "M10.519 29.92c-.411 0-3.108-3.548-5.553-7.537C3.112 19.358 0 13.789 0 10.5a10.5 10.5 0 0 1 21 0c0 3.292-3.1 8.86-4.946 11.886-2.437 3.986-5.125 7.534-5.535 7.534zM10.5 6a4.5 4.5 0 1 0 4.5 4.5A4.5 4.5 0 0 0 10.5 6z",
  className: "cls-2",
  "data-name": "Subtraction 1",
  transform: "translate(7.499 3)"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMinimartGradeE);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/minimartGradeE.9353970a468050745ad73a41c48dd10c.svg";